import React from "react";
import ImgPhone from '../images/phone-notif.png'
import ImgnoPaper from '../images/phone-stop-paper.png'
import ImgActuLocal from '../images/actu-local.png'
import ImgTamp from '../images/tamp-sign.png'
import ImgCalendar from '../images/calendar.png'

function Card({ children, className = "" }) {
  return (
    <div
      className={
        "rounded-[22px] sm:rounded-3xl bg-[#F2F2F2]  shadow-[0_2px_12px_rgba(0,0,0,0.06)] p-6 sm:p-7 md:p-8 " +
        className
      }
    >
      {children}
    </div>
  );
}

export default function PourquoiPacte() {
  return (
    <section
      id="pourquoi"
      className="relative mx-auto max-w-[1519px] px-4 sm:px-6 lg:px-8 py-10 sm:py-14 lg:py-16"
    >
      <h2 className="text-3xl sm:text-4xl font-asap font-semibold tracking-tight mb-6 sm:mb-8">
        Pourquoi PACTE ?
      </h2>
      <div
        aria-hidden
        className="pointer-events-none absolute -right-36 top-[55%] translate-y-[-50%] hidden md:block"
      >
        <img src={ImgTamp} alt="" className="h-[600px]" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-[60%_40%] gap-6 lg:gap-7 mb-6">
        <Card>
          <h3 className="text-lg font-asap sm:text-2xl font-semibold mb-2">
            Les événements près de chez vous
          </h3>
          <p className="text-sm sm:text-base text-neutral-700">
            Ne manquez plus aucun événement local : marchés, animations ou forums... grâce à l'app PACTE vous êtes directement informés.
          </p>
          <div className="relative mt-6 h-[220px] sm:h-[260px] md:h-[280px]">
            <img
              src={ImgCalendar}
              alt="Aperçu offres locales"
              className="absolute -bottom-8"
            />
          </div>
        </Card>
        <Card className="relative overflow-hidden">
          <h3 className="text-lg font-asap sm:text-2xl font-semibold mb-2">
            Ne ratez plus aucune offre locale
          </h3>
          <p className="text-sm sm:text-base text-neutral-700">
            Grâce à l'app PACTE, gardez le lien avec vos commerces de proximité et
            bénéficiez des offres du moment.
          </p>
          <div className="relative mt-6 h-[220px] sm:h-[260px] md:h-[280px]">
            <img
              src={ImgPhone}
              alt="Aperçu offres locales"
              className="absolute -bottom-8"
            />
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-[40%_60%] gap-6 lg:gap-7">
        <Card>
          <h3 className="text-lg font-asap sm:text-2xl font-semibold mb-2">
            Fini les cartes papier
          </h3>
          <p className="text-sm sm:text-base text-neutral-700">
            Avec notre application, retrouvez les cartes fidélité de tes commerces claixois
            directement dans votre téléphone. Plus besoin de papier, tout est
            centralisé dans l’app.
          </p>
          <div className="relative mt-6 h-[220px] sm:h-[260px] md:h-[280px]">
            <img
              src={ImgnoPaper}
              alt="Aperçu offres locales"
              className="absolute -bottom-8"
            />
          </div>
        </Card>

        <Card className="relative">
          <h3 className="text-lg font-asap sm:text-2xl font-semibold mb-2">
            Toute l’info locale de Claix dans ta poche
          </h3>
          <p className="text-sm sm:text-base text-neutral-700">
            Restez informé des actualités, événements et nouveautés des commerces
            de Claix. L’app PACTE vous connecte à tout ce qui se passe proche de chez vous.
          </p>
          <div className="relative mt-6 h-[220px] sm:h-[260px] md:h-[280px]">
            <img
              src={ImgActuLocal}
              alt="Aperçu offres locales"
              className="absolute -bottom-8"
            />
          </div>
        </Card>
      </div>
    </section>
  );
}